import './App.css';
import React, {useEffect, useState} from 'react';
import DebounceSelect from './components/DebounceSelect/DebounceSelect';
import CFCard from './components/CFCard/CFCard';
import { fetchCF, fetchCityList } from './services/api';
import { ConfigProvider, theme, Form, Select } from 'antd';

const App = () => {
  const [cityName, setCityName] = useState(() => localStorage.getItem('cityName') || null);
  const [latlong, setLatLong] = useState(() => localStorage.getItem('latlong') || null);
  const [std, setStd] = useState(() => localStorage.getItem('selectedStd') || 'sae');
  const [cfData, setCFData] = useState(null);

  const language = navigator.language.startsWith('pt')
    ? 'pt'
    : navigator.language.startsWith('es')
    ? 'es'
    : 'en';

  const translations = {
    es: {
      title: "Calculador de Factor de Corrección Climático Accudyno",
      location: "Localidad",
      standard: "Norma",
      selectPlaceholder: "Seleccione la localidad",
      mapLink: "Ver ubicación en Google Maps",
      updated: "Última actualización",
      temperature: "Temperatura",
      humidity: "Humedad",
      pressure: "Presión",
      correctionFactor: "Factor de corrección",
      standardLabel: "Norma"
    },
    pt: {
      title: "Calculadora de Fator de Correção Climática Accudyno",
      location: "Localidade",
      standard: "Norma",
      selectPlaceholder: "Selecione a localidade",
      mapLink: "Ver local no Google Maps",
      updated: "Última atualização",
      temperature: "Temperatura",
      humidity: "Umidade",
      pressure: "Pressão",
      correctionFactor: "Fator de correção",
      standardLabel: "Norma"
    },
    en: {
      title: "Accudyno Climate Correction Factor Calculator",
      location: "Location",
      standard: "Standard",
      selectPlaceholder: "Select location",
      mapLink: "View location on Google Maps",
      updated: "Last updated",
      temperature: "Temperature",
      humidity: "Humidity",
      pressure: "Pressure",
      correctionFactor: "Correction Factor",
      standardLabel: "Standard"
    },
  };

  const t = translations[language];

  useEffect(() => {
    if (latlong && std) {
      const [lat, lon] = latlong.split(',');
      fetchCF(lat, lon, std)
        .then((response) => setCFData(response))
        .catch((error) => console.error('Error fetching CF:', error));
    }
    if (std) localStorage.setItem('selectedStd', std);
    if (latlong) localStorage.setItem('latlong', latlong);
  }, [latlong, std]);

  useEffect(() => {
    if (cityName) localStorage.setItem('cityName', cityName);
  }, [cityName]);

  const handleStdChange = (value) => setStd(value);

  const handleSelectChange = (value, selectedOption) => {
    setCityName(value);
    setLatLong(selectedOption.latlong);
  };

  const getLocalTime = (timestamp) => {
    if (!timestamp) return null;
    return new Date(timestamp * 1000).toLocaleString();
  };

  const getMapLink = (latlong) => `https://www.google.com/maps/place/${latlong}`;

  return (
    <ConfigProvider theme={{ algorithm: theme.lightAlgorithm }}>
      <div className="calculator-container">
        <h1>{t.title}</h1>
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 14 }} layout="horizontal" style={{ maxWidth: 600 }}>
          <Form.Item label={t.location}>
            <DebounceSelect
              id="localidad"
              value={cityName}
              placeholder={t.selectPlaceholder}
              fetchOptions={fetchCityList}
              onChange={(newValue) => setCityName(newValue)}
              onSelect={handleSelectChange}
            />
          </Form.Item>
          <Form.Item label={t.standard}>
            <Select defaultValue={std} onChange={handleStdChange}>
              <option value="sae">SAE J1349/2004</option>
              <option value="iso">ISO 1585</option>
              <option value="ewg">EWG 80/1269</option>
              <option value="din">DIN 70020</option>
              <option value="j607">SAE J607</option>
              <option value="jis">JIS D 1001</option>
            </Select>
          </Form.Item>
        </Form>
        {cfData && (
          <div>
            <CFCard
              city={cityName}
              temperature={cfData.temperature}
              humidity={cfData.humidity}
              pressure={cfData.pressure}
              correctionFactor={cfData.cf}
              standard={cfData.std}
              labels={{
                temperature: t.temperature,
                humidity: t.humidity,
                pressure: t.pressure,
                correctionFactor: t.correctionFactor,
                standard: t.standardLabel,
              }}
            />
            {cfData.dt && <p>{t.updated}: {getLocalTime(cfData.dt)}</p>}
            {latlong && (
              <a className="footnote" href={getMapLink(latlong)} target="_blank" rel="noopener noreferrer">
                {t.mapLink}
              </a>
            )}
          </div>
        )}
      </div>
    </ConfigProvider>
  );
};

export default App;
